//MODULES
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatSidenavModule } from '@angular/material/sidenav';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { ToastrModule } from 'ngx-toastr';
import { CoreModule } from './core/core.module';
import { ToolbarModule } from './pages/public/toolbar/toolbar.module';
import { SharedModule } from './shared/shared.module';
//COMPONENTS
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AppComponent } from './app.component';
import { AppRoutes } from './app.routing';
import { HeaderComponent } from './core/components/header/header.component';
import { LayoutComponent } from './core/components/layout/layout.component';
import { AuthGuard } from './core/guards/auth.guard';
import { TokenInterceptorService } from './core/interceptor/token.interceptor';
import { IdentityService } from './core/services/identity.service';
import { StorageService } from './core/services/storage.service';
import { YacaToast } from './shared/components/snackbars/yaca.toast';
import { MessageWarnModule } from './pages/public/message-warn/message-warn.module';
// import { ServiceWorkerModule, SwUpdate } from '@angular/service-worker';
import { PagesModule } from './pages/pages.module';
import { FooterModule } from './pages/public/footer/footer.module';
import { BrowserModule } from '@angular/platform-browser';
import { CloverService } from './core/services/clover.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { RecoveryPasswordModule } from './pages/public/recovery-password';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { runtimeEnv } from 'src/environments/env-loader';
import { MaterialModule } from './core/material/material.module';

@NgModule({
  declarations: [AppComponent, LayoutComponent, HeaderComponent, YacaToast],
  imports: [
    FooterModule,
    SharedModule,
    CoreModule,
    RouterModule.forRoot(AppRoutes, { useHash: true }), //TODO - undo this change
    HttpClientModule,
    BrowserAnimationsModule,
    BrowserModule,
    ToastrModule.forRoot({
      toastComponent: YacaToast,
      timeOut: 2000,
      positionClass: 'toast-bottom-center',
      preventDuplicates: true
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    MatDialogModule,
    ToolbarModule,
    MessageWarnModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    NgIdleKeepaliveModule.forRoot(),
    ModalModule,
    MaterialModule,
    PagesModule,
    RecoveryPasswordModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: runtimeEnv.PRODUCTION,
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  exports: [RouterModule],
  providers: [
    StorageService,
    IdentityService,
    AuthGuard,
    CloverService,
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorService, multi: true },
    { provide: MAT_DATE_LOCALE, useValue: { useUtc: true } },
    { provide: MatPaginatorIntl, useValue: getEspPaginatorIntl() }
  ],
  // { provide: LocationStrategy, useClass: HashLocationStrategy }
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}
export function httpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
export function getEspPaginatorIntl() {
  const paginatorIntl = new MatPaginatorIntl();
  paginatorIntl.itemsPerPageLabel = 'Items por página:';
  paginatorIntl.nextPageLabel = 'Página siguiente';
  paginatorIntl.previousPageLabel = 'Página anterior';
  paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length == 0 || pageSize == 0) {
      return `0 de ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return `${startIndex + 1} - ${endIndex} de ${length}`;
  };
  return paginatorIntl;
}
